"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LevelTestPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const level_1 = require("../../../../network/level");
const use_lazy_promise_1 = require("../../../../hook/use-lazy-promise");
const fetch_result_renderer_1 = require("../../../../component/fetch-result-renderer");
const material_1 = require("@mui/material");
const alert_context_1 = require("../../../../context/alert-context");
const question_renderer_1 = require("../../component/question-renderer");
const answer_1 = require("../../model/answer");
const user_context_1 = require("../../../../context/user-context");
const button_1 = require("../../../../component/input/button");
const log_1 = require("../../../../model/log");
const log_view_layout_1 = require("../../../../component/log-view-layout");
exports.LevelTestPage = (0, react_1.memo)(() => {
    const { questionId } = (0, react_router_dom_1.useParams)();
    const [answer, setAnswer] = (0, react_1.useState)();
    const theme = (0, material_1.useTheme)();
    const alert = (0, alert_context_1.useAlert)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { refresh: refreshUserMeta } = (0, user_context_1.useUserUpdate)();
    const { result: startResult, status: startQuizStatus, error: startQuizError, execute: executeStartLevelTest, } = (0, use_lazy_promise_1.useLazyPromise)(level_1.startLevelTest);
    const { result: questionInfo, status, error, execute: executeFetchQuestion, } = (0, use_lazy_promise_1.useLazyPromise)(level_1.getLevelQuestion);
    const { result: submitResult, status: submitStatus, error: submitError, execute: executeSubmit, } = (0, use_lazy_promise_1.useLazyPromise)(level_1.submitLevelAnswer);
    (0, react_1.useEffect)(() => {
        if (!questionId) {
            executeStartLevelTest();
        }
        else {
            executeFetchQuestion(questionId);
        }
        setAnswer(null);
    }, [questionId, executeFetchQuestion, executeStartLevelTest]);
    const handleAnswerChange = (0, react_1.useCallback)((newAnswer) => {
        setAnswer(newAnswer);
    }, [setAnswer]);
    const handleSubmit = (0, react_1.useCallback)(() => {
        if (!questionInfo || !answer) {
            return;
        }
        executeSubmit(questionInfo.question.id, answer, !questionInfo.hasNext);
    }, [answer, executeSubmit, questionInfo]);
    const submitEnabled = (0, react_1.useMemo)(() => {
        return (Boolean(answer) && !!questionInfo && submitStatus !== use_lazy_promise_1.FetchStatus.Loading);
    }, [answer, questionInfo, submitStatus]);
    (0, react_1.useEffect)(() => {
        if (submitStatus === use_lazy_promise_1.FetchStatus.Success && submitResult) {
            if (submitResult.nextQuestionId && !submitResult.isFinished) {
                navigate(`/level/test/${submitResult.nextQuestionId}`);
            }
            else {
                refreshUserMeta();
                navigate("/level/result");
            }
        }
        else if (submitError) {
            alert.showAlert(`Failed to submit answer: ${submitError.message}`, alert_context_1.AlertType.Error);
        }
    }, [
        submitResult,
        submitError,
        alert,
        submitStatus,
        navigate,
        refreshUserMeta,
    ]);
    return questionId ? ((0, jsx_runtime_1.jsx)(log_view_layout_1.LogViewLayout, { eventName: log_1.LogEventViewName.LevelTestPage, children: (0, jsx_runtime_1.jsx)(fetch_result_renderer_1.FetchResultRenderer, { result: questionInfo, status: status, errorMessages: error === null || error === void 0 ? void 0 : error.message, sx: {
                flex: 1,
                width: "100%",
            }, children: (data) => {
                return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { flex: 1, direction: "column", spacing: 2, padding: 4, children: [(0, jsx_runtime_1.jsx)(button_1.Button, { variant: "contained", onClick: handleSubmit, disabled: !submitEnabled, startIcon: submitStatus === use_lazy_promise_1.FetchStatus.Loading && ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, { sx: { width: theme.spacing(2), height: theme.spacing(2) }, size: "small", color: "secondary" })), eventName: data.hasNext
                                ? log_1.LogEventClickName.LevelTestNext
                                : log_1.LogEventClickName.LevelTestSubmit, sx: { alignSelf: "flex-end", width: "fit-content" }, children: data.hasNext ? "Next Question" : "Submit" }), (0, jsx_runtime_1.jsx)(question_renderer_1.QuestionRenderer, { question: data.question, onAnswerChange: handleAnswerChange, sx: { flex: 1 }, userAnswerState: answer
                                ? {
                                    answer: answer,
                                    state: answer_1.AnswerResultState.Unknown,
                                }
                                : undefined }, data.question.id)] }));
            } }) })) : ((0, jsx_runtime_1.jsx)(fetch_result_renderer_1.FetchResultRenderer, { result: startResult, status: startQuizStatus, errorMessages: startQuizError === null || startQuizError === void 0 ? void 0 : startQuizError.message, sx: {
            flex: 1,
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
        }, children: (data) => ((0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: `/level/test/${data.questionId}`, replace: true })) }));
});
exports.LevelTestPage.displayName = "LevelPage";
exports.default = exports.LevelTestPage;
